import { gql, useQuery } from '@apollo/client';

const GET_BROKERAGE_ID = gql`
  query GetAgent($agentCustomerUuid: String!) {
    odProtosAgentsServicesAgent {
      getAgent(input: { agentCustomerId: $agentCustomerUuid }) {
        agent {
          id
          brokerageId
        }
      }
    }
  }
`;

export const useGetBrokerageId = (agentCustomerUuid: string) => {
  const { data, error, loading } = useQuery(GET_BROKERAGE_ID, {
    variables: { agentCustomerUuid },
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
  });
  const brokerageId = data?.odProtosAgentsServicesAgent?.getAgent?.agent?.brokerageId;

  return { brokerageId, error, loading };
};
